module.exports = __webpack_public_path__ + "static/media/commandsMenu.a7eb50cb.png";